.list {
  display: grid;
  gap: var(--space-4) var(--space-6);
}

.twoColumns {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.item {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.wide {
  grid-column: 1 / -1;
}

.label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-muted);
}

.value {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-text);
  overflow-wrap: anywhere;
}

.empty {
  color: var(--color-text-muted);
  font-weight: var(--font-weight-medium);
}

@media (width < 30rem) {
  .twoColumns {
    grid-template-columns: minmax(0, 1fr);
  }
}
